// extracted by mini-css-extract-plugin
export var cancelButton = "unified-search-input-module--cancelButton--38f1c";
export var cancelIcon = "unified-search-input-module--cancelIcon--23a89";
export var dark = "unified-search-input-module--dark--6659f";
export var input = "unified-search-input-module--input--d0854";
export var searchIcon = "unified-search-input-module--searchIcon--e7680";
export var unifiedSearch = "unified-search-input-module--unifiedSearch--a43fd";